import React, { Component } from "react";
import PropTypes from "prop-types";
import { Box } from "grommet/components/Box";
import { Tabs } from "grommet/components/Tabs";
import { Tab } from "grommet/components/Tab";
import {
  titleDatiResponsabile,
  titleDatiGestore,
  titleDatiRiepilogo,
  info,
} from "../Components/TitleDispute.js";
import data from "../Data.json";
import DatiResponsabile from "../Components/DatiResponsabile";
import DatiGestore from "../Components/DatiGestore";
import DatiRiepilogo from "../Components/DatiRiepilogo";
import GestioneRichieste from "./GestioneRichieste";
import { Button } from "grommet";
import { withRouter } from "react-router-dom";
import Report from "./Report.js";
import { GetEboxListCtrl } from "../Controllers/Ebox/GetEboxListCtrl";
import { loader } from "../Utils/Utility";
import { SearchUserByPosCtrl } from "../Controllers/Ebox/SearchUserByPosCtrl.js";
import { SearchUserListBySocCtrl } from "../Controllers/Ebox/SearchUserListBySocCtrl.js";
import RegistrationResultEbox from "../Components/RegistrationResultEbox.js";
import { GetEboxProfileCtrl } from "../Controllers/Ebox/GetEboxProfileCtrl.js";
import { SearchPointOfSalesCtrl } from "../Controllers/Transaction/SearchPointOfSalesCtrl";
import { SearchPosListCtrl } from "../Controllers/Ebox/SearchPosListCtrl";
import ModalErrorTimeout from "../Components/ModalErrorTimeout";
import "./DisputeRegistered.css";

class DisputeRegistered extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      isReport: false,
      step: 1,
      gestPage: 1,
      codSocietario: sessionStorage.getItem("codSocietario"),
      ebox: sessionStorage.getItem("ebox"),
      //VALUES DATI RESPONSABILE
      data: data,
      search: "",
      selected: {},
      value: [],
      checked: "Y",
      checkedbox: "",
      openModal: false,
      openModalemail: false,
      codsocieta: sessionStorage.getItem("codesoc"),
      nome: "",
      cognome: "",
      telefono: "",
      fax: "",
      email: "",
      msgcodsoc: "",
      msgfax: "",
      msgemail: "",
      msgnumtel: "",
      type: "",
      typeManager: "",
      statusResponse: "",
      enabled: false,

      //VALUES DATI GESTORE
      codes: [],
      emailGestore: "",
      usernamePV: [],
      selectedType: "",
      selectedUser: "",
      selectedPV: "",
      selectedCode: [],
      selectedUserPV: [],
      setEmailValue: [],
      msgemailGestore: "",
      openModalpoint: false,
      showGestore: true,
      showGestori: false,
      gest: {},
      msgemailTable: [],
      errorMails: false,
      listUsername: [],
      dataDispute: [],
      dataReport: [],
      loadList: false,
      loadProfile: false,
      loader: true,
      tablePointofSales: [],
      pages: {},
      currentPage: 1,
      /*codes: [],*/
      mapGestoreUser: new Map(),
      listaCodPv: [],
      showTimeoutModal: false,
      newEmailGest: "",
    };

    this.getGestore = this.getGestore.bind(this);
    this.getList = this.getList.bind(this);
    this.switchDisputeReport = this.switchDisputeReport.bind(this);

    //DATI RESPONSABILE METHODS
    this.setSearch = this.setSearch.bind(this);
    this.setForm = this.setForm.bind(this);
    this.setRadioButton = this.setRadioButton.bind(this);
    this.setCheckbox = this.setCheckbox.bind(this);
    this.showModal = this.showModal.bind(this);
    this.activateButton = this.activateButton.bind(this);
    this.showModalemail = this.showModalemail.bind(this);
    this.closeModal = this.closeModal.bind(this);

    //DATI GESTORE METHODS
    this.showModalemailGestore = this.showModalemailGestore.bind(this);
    this.showModalpointofsale = this.showModalpointofsale.bind(this);
    this.showGestori = this.showGestori.bind(this);
    this.showGestore = this.showGestore.bind(this);
    this.closeModalGestore = this.closeModalGestore.bind(this);
    this.setSelectionType = this.setSelectionType.bind(this);
    this.setSelectionPv = this.setSelectionPv.bind(this);
    this.setSelectionUser = this.setSelectionUser.bind(this);
    this.setSelectionCode = this.setSelectionCode.bind(this);
    this.setSelectionUserPV = this.setSelectionUserPV.bind(this);
    this.emailGestore = this.emailGestore.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.setStatusResponse = this.setStatusResponse.bind(this);
    this.getList = this.getList.bind(this);
    this.setNewEmail = this.setNewEmail.bind(this);
  }

  componentWillMount() {
    const self = this;
    // if (this.state.codSocietario === '0') {
    //     this.setState({
    //         step: 5
    //     })
    // }

    var token = sessionStorage.getItem("token");
    var ids = sessionStorage.getItem("ids");

    GetEboxProfileCtrl(
      function (data, status) {
        let myMap = new Map();
        let i, j;
        let myUser = sessionStorage.getItem("user");
        let arrPv = [];
        let emailGestore = "";
        for (i = 0; i < data.listaGestoriList.length; i++) {
          let lista = data.listaGestoriList[i];
          let codGestore = lista.codGestore;
          let username = lista.user;
          let email = lista.email;
          let obj = {
            codGestore: codGestore,
            username: username,
            email: email,
          };
          if (
            emailGestore === "" &&
            (username === myUser || username === "Tutti")
          ) {
            emailGestore = email;
          }
          for (j = 0; j < lista.listaPuntiVenditaList.length; j++) {
            let codPV = lista.listaPuntiVenditaList[j].codPV;
            if (myMap.get(codPV) === undefined) {
              myMap.set(codPV, obj);
            }
            if (username === myUser || username === "Tutti") {
              arrPv.push({ code: codPV });
            }
          }
        }

        self.setState(
          {
            loadProfile: true,
            nome: data.nome,
            cognome: data.cognome,
            telefono: data.telefono,
            fax: data.fax,
            email: data.email,
            mapGestoreUser: myMap,
            listaCodPv: arrPv,
            emailGestore: emailGestore,
          },
          () => {
            self.getList();
          },
        );
      },
      function (status) {
        self.setState(
          {
            status: status,
            loadProfile: true,
          },
          function () {
            if (
              this.state.status === 500 ||
              this.state.status === 400 ||
              this.state.status === 404 ||
              this.state.status === 403
            ) {
              this.props.history.push({
                pathname: "/ErrorPage",
                state: this.state,
              });
            } else if (this.state.status === 401) {
              this.setState({
                showTimeoutModal: true,
              });
            }
          },
        );
      },
      token,
      ids,
    );

    if (this.state.codSocietario === "1") {
      SearchPointOfSalesCtrl(
        function (data, pages, currentPage) {
          self.setState({
            tablePointofSales: data === undefined ? [] : data,
            pages: pages === undefined ? [] : pages,
            currentPage: currentPage === undefined ? [] : currentPage,
          });
        },
        function (error) {
          self.setState(
            {
              status: error,
            },
            function () {
              if (
                this.state.status === 500 ||
                this.state.status === 400 ||
                this.state.status === 404 ||
                this.state.status === 403
              ) {
                this.props.history.push({
                  pathname: "/ErrorPage",
                  state: this.state,
                });
              } else if (this.state.status === 401) {
                this.setState({
                  showTimeoutModal: true,
                });
              }
            },
          );
        },
        token,
        ids,
        this.state.currentPage,
        this.state.search,
      );

      SearchPosListCtrl(
        (data) => {
          self.setState({ codes: data !== "" ? data : [] });
        },
        (error) => {
          if (
            this.state.status === 500 ||
            this.state.status === 400 ||
            this.state.status === 404 ||
            this.state.status === 403
          ) {
            this.props.history.push({
              pathname: "/ErrorPage",
              state: this.state,
            });
          } else if (this.state.status === 401) {
            this.setState({
              showTimeoutModal: true,
            });
          }
        },
        token,
        ids,
      );
    }
  }

  getList() {
    const self = this;

    GetEboxListCtrl(
      function (data) {
        self.setState({
          loadList: true,
          dataDispute: data === "" ? [] : data,
        });
      },
      function (error) {
        self.setState(
          {
            status: error,
            loadList: true,
          },
          function () {
            if (
              this.state.status === 500 ||
              this.state.status === 400 ||
              this.state.status === 404 ||
              this.state.status === 403
            ) {
              this.props.history.push({
                pathname: "/ErrorPage",
                state: this.state,
              });
            } else if (this.state.status === 401) {
              this.setState({
                showTimeoutModal: true,
              });
            }
          },
        );
      },
    );
  }

  getGestore(el) {
    this.setState({
      gestore: "Gestore " + el.selectedCode,
    });
  }

  //DATI RESPONSABILE METHODS
  setPoint(i) {
    const newSelected = this.state.selected;
    const newValue = this.state.value;
    newSelected[i] = !this.state.selected[i];
    newValue[i] = [i];

    this.setState({
      selected: newSelected,
      value: newValue,
    });
  }

  setRadioButton(event) {
    this.setState({
      checked: event.target.value,
    });
  }

  setCheckbox() {
    this.setState({
      checkedbox: !this.state.checkedbox,
    });
  }

  setSearch(event) {
    this.setState({
      search: event.target.value,
    });
  }

  setForm(event) {
    if (event.target.id === "codsoc") {
      this.setState({
        codsocieta: event.target.value,
      });
    } else if (event.target.id === "nome") {
      this.setState({
        nome: event.target.value,
      });
    } else if (event.target.id === "cognome") {
      this.setState({
        cognome: event.target.value,
      });
    } else if (event.target.id === "numtel") {
      this.setState({
        telefono: event.target.value,
      });
    } else if (event.target.id === "fax") {
      this.setState({
        fax: event.target.value,
      });
    } else if (event.target.id === "email") {
      this.setState({
        email: event.target.value,
      });
    }
  }

  showModal() {
    this.setState({
      openModal: true,
    });
  }

  showModalemail() {
    this.setState({
      openModalemail: true,
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      openModalemail: false,
    });
  }

  nextStep = () => {
    const { step, gestPage } = this.state;
    this.setState({
      step: step + 1,
      gestPage: gestPage + 1,
    });
  };

  prevStep = () => {
    const { step, gestPage } = this.state;
    this.setState({
      step: step - 1,
      gestPage: gestPage - 1,
    });
  };

  //DATI GESTORE

  showModalemailGestore() {
    this.setState({
      openModalemail: true,
    });
  }

  showModalpointofsale() {
    this.setState({
      openModalpoint: true,
    });
  }
  closeModalGestore() {
    this.setState({
      openModal: false,
      openModalemail: false,
      openModalpoint: false,
    });
  }

  setSelectionType(event) {
    let token = sessionStorage.getItem("token");
    let ids = sessionStorage.getItem("ids");
    const self = this;
    this.setState(
      {
        selectedType: event.value,
        selectedUser: "Tutti",
      },
      function () {
        if (
          this.state.selectedType === "Punto Vendita" &&
          this.state.selectedPV !== ""
        ) {
          SearchUserByPosCtrl(
            function (data) {
              self.setState({ listUsername: data !== "" ? data : [] });
            },
            function (error) {
              if (
                this.state.status === 500 ||
                this.state.status === 400 ||
                this.state.status === 404 ||
                this.state.status === 403
              ) {
                this.props.history.push({
                  pathname: "/ErrorPage",
                  state: this.state,
                });
              } else if (this.state.status === 401) {
                this.setState({
                  showTimeoutModal: true,
                });
                // logout();
                // this.props.history.push({
                //     pathname: '/login'
                // })
              }
            },
            this.state.selectedPV,
            token,
            ids,
          );
        } else if (this.state.selectedType === "Società") {
          SearchUserListBySocCtrl(
            (data) => {
              self.setState({ listUsername: data !== "" ? data : [] });
            },
            (err) => {
              if (
                this.state.status === 500 ||
                this.state.status === 400 ||
                this.state.status === 404 ||
                this.state.status === 403
              ) {
                this.props.history.push({
                  pathname: "/ErrorPage",
                  state: this.state,
                });
              } else if (this.state.status === 401) {
                this.setState({
                  showTimeoutModal: true,
                });
                // logout();
                // this.props.history.push({
                //     pathname: '/login'
                // })
              }
            },
            token,
            ids,
          );
        }
      },
    );
    if (this.state.selectedType !== "") {
      this.setState({
        selectedUser: "",
      });
    }
  }

  setSelectionUser(event) {
    this.setState({
      selectedUser: event.value,
    });
  }

  setSelectionPv(event) {
    const self = this;
    let token = sessionStorage.getItem("token");
    let ids = sessionStorage.getItem("ids");
    this.setState(
      {
        selectedPV: event.value,
      },
      () => {
        SearchUserByPosCtrl(
          (data) => {
            self.setState({ listUsername: data !== "" ? data : [] });
          },
          (error) => {
            if (
              this.state.status === 500 ||
              this.state.status === 400 ||
              this.state.status === 404 ||
              this.state.status === 403
            ) {
              this.props.history.push({
                pathname: "/ErrorPage",
                state: this.state,
              });
            } else if (this.state.status === 401) {
              this.setState({
                showTimeoutModal: true,
              });
              // logout();
              // this.props.history.push({
              //     pathname: '/login'
              // })
            }
          },
          this.state.selectedPV,
          token,
          ids,
        );
      },
    );
  }

  emailGestore(event) {
    this.setState(
      {
        emailGestore: event.target.value,
      },
      function () {
        this.validEmailGestore();
      },
    );
  }

  validEmailGestore() {
    var emailGestore = this.state.emailGestore;
    //const emailreg = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
    const emailreg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;

    if (emailGestore !== "" && emailreg.test(emailGestore) === false) {
      this.setState({
        msgemailGestore: true,
        emailGestore: "",
      });
    } else if (emailGestore !== "" && emailreg.test(emailGestore) === true) {
      this.setState({
        msgemailGestore: false,
      });
    } else if (emailGestore === "") {
      this.setState({
        msgemailGestore: false,
      });
    }
  }

  showGestori() {
    this.setState({
      showGestore: false,
      showGestori: true,
      gestPage: 4,
    });
  }

  showGestore() {
    this.setState({
      showGestore: true,
      showGestori: false,
    });
  }

  setSelectionCode(row, i, e) {
    i = row.index;
    let selectedCodes = this.state.selectedCode;
    selectedCodes[i] = e.value;
    this.setState({
      selectedCode: selectedCodes,
    });
  }

  setSelectionUserPV(row, i, e) {
    i = row.index;
    let selectedUsersPV = this.state.selectedUserPV;
    selectedUsersPV[i] = e.value;
    this.setState({
      selectedUserPV: selectedUsersPV,
    });
  }

  setEmail(row, i, e) {
    i = row.index;
    let setEmails = this.state.setEmailValue;
    setEmails[i] = e.target.value;

    this.setState(
      {
        setEmailValue: setEmails,
      },
      function () {
        this.validEmailTable();
      },
    );
  }

  validEmailTable() {
    let emails = this.state.setEmailValue;

    //const emailreg = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
    const emailreg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;

    var isMailsWrong = false;

    emails.forEach((element, index) => {
      if (element !== "" && emailreg.test(element) === false) {
        isMailsWrong = true;
      }
    });

    this.setState({
      errorMails: isMailsWrong,
    });
  }

  switchDisputeReport(e) {
    let isReportChange = e.target.id === "report-btn" ? true : false;
    this.setState({
      isReport: isReportChange,
    });
  }

  setStatusResponse(status) {
    this.setState({
      statusResponse: status,
    });
  }

  activateButton(btnState) {
    if (btnState) {
      this.setState({
        enabled: true,
      });
    }
  }

  form(step) {
    //DATI RESPONSABILE
    const {
      gest,
      data,
      search,
      selected,
      value,
      checked,
      checkedbox,
      openModal,
      openModalemail,
      codsocieta,
      nome,
      cognome,
      telefono,
      fax,
      email,
      msgcodsoc,
      msgfax,
      msgemail,
      msgnumtel,
      //DATI GESTORE
      codes,
      emailGestore,
      msgemailGestore,
      usernamePV,
      selectedType,
      type,
      typeManager,
      selectedUser,
      selectedPV,
      selectedCode,
      selectedUserPV,
      setEmailValue,
      masgemail,
      openModalpoint,
      showGestore,
      showGestori,
      msgemailTable,
      errorMails,
      dataDispute,
      statusResponse,
      listUsername,
      tablePointofSales,
      currentPage,
      pages,
      mapGestoreUser,
      newEmailGest,
    } = this.state;

    //DATI RESPONSABILE
    const values = {
      gest,
      data,
      search,
      selected,
      value,
      checked,
      checkedbox,
      openModal,
      openModalemail,
      codsocieta,
      nome,
      cognome,
      telefono,
      fax,
      email,
      msgcodsoc,
      msgfax,
      msgemail,
      msgnumtel,
      //DATI GESTORE
      codes,
      emailGestore,
      msgemailGestore,
      usernamePV,
      selectedType,
      type,
      typeManager,
      selectedUser,
      selectedPV,
      selectedCode,
      selectedUserPV,
      setEmailValue,
      masgemail,
      openModalpoint,
      showGestore,
      showGestori,
      msgemailTable,
      errorMails,
      dataDispute,
      statusResponse,
      listUsername,
      tablePointofSales,
      currentPage,
      pages,
      mapGestoreUser,
      newEmailGest,
    };

    switch (step) {
      case 1:
        return (
          <DatiResponsabile
            nextStep={this.nextStep}
            setSearch={this.setSearch}
            setForm={this.setForm}
            setRadioButton={this.setRadioButton}
            setCheckbox={this.setCheckbox}
            showModal={this.showModal}
            showModalemail={this.showModalemail}
            closeModal={this.closeModal}
            values={values}
          />
        );
      case 2:
        return (
          <DatiGestore
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            showModalemailGestore={this.showModalemailGestore}
            showModalpointofsale={this.showModalpointofsale}
            showGestori={this.showGestori}
            showGestore={this.showGestore}
            setEmail={this.setEmail}
            closeModalGestore={this.closeModalGestore}
            closeModal={this.closeModal}
            setSelectionType={this.setSelectionType}
            setSelectionPv={this.setSelectionPv}
            setSelectionUser={this.setSelectionUser}
            setSelectionCode={this.setSelectionCode}
            setSelectionUserPV={this.setSelectionUserPV}
            emailGestore={this.emailGestore}
            values={values}
          />
        );
      case 3:
        return (
          <DatiRiepilogo
            setStatus={this.setStatusResponse}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            values={values}
          />
        );
      case 4:
        return <RegistrationResultEbox values={values} />;
      default:
        return null;
      // case 5:
      //     return <DatiGestoreEmail
      //         values={values}
      //         nextStep={this.nextStep}
      //         showModalemail={this.showModalemail}
      //         closeModal={this.closeModal}
      //         setNewEmail={this.setNewEmail}
      //         emailGestore={this.state.emailGestore}
      //     />
      // case 6:
      //     return <RiepilogoGestoreEmail
      //         values={values}
      //         nextStep={this.nextStep}
      //         prevStep={this.prevStep}
      //         emailGestore={this.state.emailGestore}
      //     />
      // case 7:
      //     return <ModifyEmailEbox
      //         values={values}
      //     />
    }
  }
  setNewEmail(newEmailGest) {
    this.setState({
      newEmailGest: newEmailGest,
    });
  }

  showDisputeGestore() {
    const listaCodPv = this.state.listaCodPv;
    if (this.state.codSocietario === "1") {
      if (this.state.isReport) {
        return <Report data={this.state.dataReport} listaCodPv={listaCodPv} />;
      } else {
        return <GestioneRichieste data={this.state.dataDispute} />;
      }
    } else if (this.state.codSocietario === "0" && this.state.ebox === "SI") {
      if (this.state.isReport) {
        return <Report data={this.state.dataReport} listaCodPv={listaCodPv} />;
      } else {
        return <GestioneRichieste data={this.state.dataDispute} />;
      }
    } else {
      return <Report data={this.state.dataReport} listaCodPv={listaCodPv} />;
    }
  }

  render() {
    const { step } = this.state;

    const accedi = (
      <Box style={{ padding: "60px 20px 0 20px" }}>
        <Box justify="center" direction="row">
          <Button
            id="dispute-btn"
            className={this.state.isReport ? "btnformUnselected" : "btnform"}
            style={{ width: "170px", margin: "0 30px 30px 0" }}
            onClick={() => this.setState({ isReport: false })}
            aria-label="Vai alla sezione Gestione Dispute per creare nuove contestazioni"
          >
            Gestione Dispute
          </Button>
          <Button
            id="report-btn"
            className={this.state.isReport ? "btnform" : "btnformUnselected"}
            style={{ width: "170px", marginBottom: "30px" }}
            onClick={() => this.setState({ isReport: true })}
            aria-label="Vai alla sezione Report per visualizzare le dispute esistenti"
          >
            Report
          </Button>
        </Box>
      </Box>
    );

    return (
      <Box>
        {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ""}
        <Box
          align="center"
          className="content dispute-registered-page"
          style={{ backgroundColor: "#f9f9f9", marginTop: "0" }}
        >
          <Box className="contentbox">
            {this.state.step === 1
              ? titleDatiResponsabile
              : this.state.step === 2
                ? titleDatiGestore
                : this.state.step === 3
                  ? titleDatiRiepilogo
                  : null}
            {this.state.loadList && this.state.loadProfile ? (
              <Box direction="row">
                <Tabs className="dispute_tabs_container">
                  <Tab id="btn-info" title="Informazioni">
                    {info}
                  </Tab>
                  {this.state.ebox === "SI" &&
                  this.state.codSocietario === "1" ? (
                    <Tab id="btn-profilo" title="Il mio profilo">
                      {this.form(step)}
                    </Tab>
                  ) : null}
                  {this.state.ebox === "SI" ? (
                    <Tab
                      id="btn-accedi"
                      title="Accedi al servizio"
                      onClick={this.getList}
                    >
                      {accedi}
                      {this.showDisputeGestore()}
                    </Tab>
                  ) : null}
                </Tabs>
              </Box>
            ) : (
              loader
            )}
          </Box>
        </Box>
      </Box>
    );
  }
}
export default DisputeRegistered = withRouter(DisputeRegistered);
